<template>
  <li class="flex flex-col gap-xs">
    <div class="animate-pulse bg-skeleton rounded-md w-cardThumbnailW h-cardThumbnailH"></div>
    <TextSkeleton
      class="h-lg rounded-md"
      pulse
      :characters="15"
    />
  </li>
</template>

<script>
import TextSkeleton from '@/components/library/skeletons/TextSkeleton.vue';

export default {
  components: { TextSkeleton },
};
</script>
